import type { PostingDimensions } from '@festina/legalentity-general-types/legalentity'
import type { Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { IdToCompany } from '../idToLec/IdToCompany'
import { IdToPerson } from '../idToLec/IdToPerson'

type Props = {
  dimensions: Optional<PostingDimensions>
}
export const MoneyOutReceiver = ({ dimensions }: Props) => {
  const translate = useTranslate()

  return (
    <>
      {dimensions?.dim1 === 'PAL_RECEIVER' ||
      dimensions?.dim2 === 'PAL_RECEIVER' ? (
        <>{translate('moneyOut.receiverPal')}</>
      ) : (
        <>
          {dimensions?.dim1 ? (
            <IdToPerson
              id={dimensions?.dim1}
              format="externalId"
              // Should not use a link here as this entity might not be correct
              // When we get a new business service this can be changed again LIFE-10094
              link="never"
            />
          ) : (
            <IdToCompany
              id={dimensions?.dim2}
              format="externalId"
              // Should not use a link here as this entity might not be correct
              // When we get a new business service this can be changed again LIFE-10094
              link="never"
            />
          )}
        </>
      )}
    </>
  )
}
